import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=c2adf796&"
import script from "./AccountSetup.vue?vue&type=script&lang=js&"
export * from "./AccountSetup.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=c2adf796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VCard,VCardText,VCol,VProgressLinear,VRow,VSpacer,VToolbar,VToolbarTitle})
